export default template;
function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (encodeURIComponent, menus, newMenuEnabled, newPageEnabled, pages) {
      pug_html = pug_html + "\u003Cdiv class=\"function-body\"\u003E\u003Ch2\u003EPages\u003C\u002Fh2\u003E\u003Cdiv class=\"pages\"\u003E";
// iterate pages
;(function(){
  var $$obj = pages;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var page = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"page\"\u003E\u003Cdiv class=\"name\"\u003E\u003Ca" + (pug_attr("href", `#/website/edit/page/${encodeURIComponent(page.path)}`, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = page.name || page.path) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
if (! page.enabled) {
pug_html = pug_html + "\n(hidden)";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var page = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"page\"\u003E\u003Cdiv class=\"name\"\u003E\u003Ca" + (pug_attr("href", `#/website/edit/page/${encodeURIComponent(page.path)}`, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = page.name || page.path) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
if (! page.enabled) {
pug_html = pug_html + "\n(hidden)";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

if (newPageEnabled) {
pug_html = pug_html + "\u003Cbutton class=\"add-page\"\u003ECreate new page\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Ch2\u003EMenus\u003C\u002Fh2\u003E\u003Cdiv class=\"menus\"\u003E";
// iterate menus
;(function(){
  var $$obj = menus;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var menu = $$obj[pug_index1];
pug_html = pug_html + "\u003Cdiv class=\"menu\"\u003E\u003Cdiv class=\"name\"\u003E\u003Ca" + (pug_attr("href", `#/website/edit/menu/${encodeURIComponent(menu.name)}`, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = menu.name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var menu = $$obj[pug_index1];
pug_html = pug_html + "\u003Cdiv class=\"menu\"\u003E\u003Cdiv class=\"name\"\u003E\u003Ca" + (pug_attr("href", `#/website/edit/menu/${encodeURIComponent(menu.name)}`, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = menu.name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

if (newMenuEnabled) {
pug_html = pug_html + "\u003Cbutton class=\"add-menu\"\u003ECreate new menu\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "encodeURIComponent" in locals_for_with ?
        locals_for_with.encodeURIComponent :
        typeof encodeURIComponent !== 'undefined' ? encodeURIComponent : undefined, "menus" in locals_for_with ?
        locals_for_with.menus :
        typeof menus !== 'undefined' ? menus : undefined, "newMenuEnabled" in locals_for_with ?
        locals_for_with.newMenuEnabled :
        typeof newMenuEnabled !== 'undefined' ? newMenuEnabled : undefined, "newPageEnabled" in locals_for_with ?
        locals_for_with.newPageEnabled :
        typeof newPageEnabled !== 'undefined' ? newPageEnabled : undefined, "pages" in locals_for_with ?
        locals_for_with.pages :
        typeof pages !== 'undefined' ? pages : undefined));
    ;;return pug_html;}